<template>
  <input
    v-model="query"
    v-on:keyup="_keyupListener"
    type="search"
    class="form-control"
  >
</template>

<script>
import SessionStorage from '../../model/storage/session-storage'

export default {
  data () {
    return {
      query:   null,
      timeout: null
    }
  },

  created () {
    this._initQuery()
  },

  watch: {
    '$route': function () {
      this._initQuery()
    }
  },

  methods: {

    clear () {
      this.query = null
      SessionStorage.setArrayItem(SessionStorage.GRID_QUERY, { key: window.location.href, text: this.query })
      this.$emit('changeQuery', this.query)
    },

    /**
     *
     * @private
     */
    _initQuery () {
      // @TODO: this must be delegate to someone else
      let query  = SessionStorage.getArrayItem(SessionStorage.GRID_QUERY, window.location.href)
      this.query = query ? query.text : null

      if (this.query === '' || !this.query) {
        return
      }

      this.$emit('changeQuery', this.query)
    },

    /**
     *
     * @private
     */
    _keyupListener () {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        SessionStorage.setArrayItem(SessionStorage.GRID_QUERY, { key: window.location.href, text: this.query })
        this.$emit('changeQuery', this.query)
      }, 1000)
    }
  }
}
</script>

<style scoped>

</style>
